<script>
    import { fade } from 'svelte/transition';
    import Icon from "./Icon.svelte"
    export let showModal = false;
</script>

{#if showModal}
    <div transition:fade="{{duration: 100}}" class="bg" on:click|self>
        <div class="modal">
            <div class="top">
                <button on:click><Icon class="close" name="x-circle" width="1.2em" height="1.2em" strokeWidth="1.5px"/>Close</button>
            </div>
            <div class="body">
                <slot></slot>
            </div>
        </div>
    </div>
{/if}

<style>
    .bg {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 100;
    }

    .modal {
        position: relative;
        background: var(--background-body);
        width: 80%;
        margin: 3em auto;
        border-radius: 6px;
        padding: 1em;
        overflow-y: initial;
    }

    @media (min-width: 1190px) {
		.modal {
			width: 40%;
		}
	}

    .top {
        position: absolute;
        right: 0.6em;
    }

    .body {
        max-height: 80vh;
        overflow-y: auto;
    }
</style>